module.exports = __webpack_public_path__ + "img/Flag_of_Botswana.f9750ef2.svg";